import { render, staticRenderFns } from "./fault_history.vue?vue&type=template&id=b5a913b4"
import script from "./fault_history.vue?vue&type=script&lang=js"
export * from "./fault_history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports